import * as trace from 'owa-trace';
import debounce from 'lodash-es/debounce';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import UserConfigurationDictionaryObject from 'owa-service/lib/contract/UserConfigurationDictionaryObject';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

export const USER_OPTIONS_BASEFOLDERID_NAME: DistinguishedFolderIdName = 'root';
const UPDATE_FOLDER_VIEW_STATE_DELAY_MS = 10 * 1000;

/**
 * Delay update the folder view state service
 * @param userConfiguration the user configuration
 */
export function updateFolderViewStateService(userConfiguration: OwaUserConfiguration) {
    const folderViewState = userConfiguration.ViewStateConfiguration.FolderViewState;

    if (folderViewState) {
        updateUserConfigurationService(
            VIEW_STATE_CONFIGURATION,
            {
                // Key
                Type: 'String',
                Value: ['FolderViewState'],
            },
            {
                // Value
                Type: 'StringArray',
                Value: folderViewState,
            }
        );
    }
}

/**
 * Update the user configuration service internal
 * @param userConfigurationName the user configuration name
 * @param key the key which is the field to update
 * @param value the value of the field
 */
function updateUserConfigurationService(
    userConfigurationName: string,
    key: UserConfigurationDictionaryObject,
    value: UserConfigurationDictionaryObject
): Promise<SingleResponseMessage> {
    const newUserConfiguration = serviceUserConfiguration({
        UserConfigurationName: userConfigurationNameType({
            Name: userConfigurationName,
            BaseFolderId: distinguishedFolderId({
                Id: USER_OPTIONS_BASEFOLDERID_NAME,
            }),
        }),
        Dictionary: [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject(key),
                DictionaryValue: userConfigurationDictionaryObject(value),
            }),
        ],
    });

    return updateUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: updateUserConfigurationOwaRequest({
            UserConfiguration: newUserConfiguration,
        }),
    })
        .then(response => response.Body.ResponseMessages.Items[0])
        .catch(error => {
            trace.errorThatWillCauseAlert('Unable to update folderViewState in userConfiguration');
            return null;
        });
}

export default debounce(updateFolderViewStateService, UPDATE_FOLDER_VIEW_STATE_DELAY_MS);
